module.exports = __webpack_public_path__ + "static/media/ar.4f098aa5.svg";